export const objectDefault = {
  // h_id: 4,

  h_categoria: "",
  h_parametro: "",
  h_usuario: "",
  h_empresa: "",
  h_fec_reg: "",
};

	// "h_id": 1,
	// 			"h_categoria": null,
	// 			"h_parametro": "Hemograma Procyte IDEXX",
	// 			"h_usuario": "admin",
	// 			"h_empresa": "DEMO",
	// 			"h_fec_reg": "2025-06-06T17:26:54.000Z"

export const columns = [
  // {
  //   id: "h_categoria",
  //   label: "Categoria",
  //   minWidth: 25,
  //   tipo: "string",
  //   propiedad: "h_categoria",
  // },
  {
    id: "h_parametro",
    label: "Parametro",
    minWidth: 25,
    tipo: "string",
    propiedad: "h_parametro",
  },
  {
    id: "h_usuario",
    label: "User",
    minWidth: 25,
    tipo: "string",
    propiedad: "h_usuario",
  },
  {
    id: "h_fec_reg",
    label: "Fec. Reg.",
    minWidth: 25,
    tipo: "string",
    propiedad: "h_fec_reg",
  },
];
